import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from '../../../../../../../core/shared/widget/widget-data';
import {FilterCriteria} from '../../../../../../../core/shared/filter/api/filter.criteria';
import {WidgetFactory} from '../../../../../../../core/shared/widget/service/widget.factory';

@Component({
    selector: 'bm-customer-billing-transaction-type-billing-run-types',
    templateUrl: 'bm-customer-billing-transaction-type-billing-run-types.component.html',
    standalone: false
})
export class BmCustomerBillingTransactionTypeBillingRunTypesComponent implements OnInit, OnChanges, OnDestroy {

    initialized: boolean = false;

    @Input() customerBillingTransactionTypeId: number;

    billingRunTypesWidgetData: WidgetData;

    ngOnInit(): void {
        this.refreshComponent();
    }

    refreshComponent() {
        // A BillingRunType references the CustomerBillingTransactionType in up to 5 distinct roles
        // (contract debit/credit, SEPA credit/debit, SEPA charges). Match rows where ANY of those
        // foreign keys points at this CustomerBillingTransactionType — i.e. OR across the 5 fields.
        const filterCriteria = FilterCriteria.createOr(
            FilterCriteria.create('e.transactionTypeContractDebit.id', FilterCriteria.cOperatorEqual, this.customerBillingTransactionTypeId),
            FilterCriteria.create('e.transactionTypeContractCredit.id', FilterCriteria.cOperatorEqual, this.customerBillingTransactionTypeId),
            FilterCriteria.create('e.transactionTypeSepaCredit.id', FilterCriteria.cOperatorEqual, this.customerBillingTransactionTypeId),
            FilterCriteria.create('e.transactionTypeSepaDebit.id', FilterCriteria.cOperatorEqual, this.customerBillingTransactionTypeId),
            FilterCriteria.create('e.transactionTypeSepaCharges.id', FilterCriteria.cOperatorEqual, this.customerBillingTransactionTypeId),
        );

        this.billingRunTypesWidgetData = WidgetFactory.createWidgetTableEntityBasicQl(
            `bm.customer.billing.transaction.type.billing.run.types.widget.data.${this.customerBillingTransactionTypeId}`,
            'Abrechnungslauftypen',
            'bm.BillingRunType',
            [filterCriteria]
        );

        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['customerBillingTransactionTypeId']) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }
}
